import HomeGuideSteps from "@/util/guide-step/HomeGuideSteps";
import GuideStepHelper from "@/util/guide-step/GuideStepHelper";
import TBDriver from "@tibi/vue-driver/TBDriver.js";
import ConstantsGuideCode from "@/util/constants/ConstantsGuideCode";
export default {
    data() {
        return {
            isFirstCheckRecordGuide: true, // 是否第一次检测记录引导
            recordGuideId: "step209", // 检测记录引导ID
        };
    },
    methods: {
        // ============================================操作引导 ==============================================//
        /**
         * 初始化操作引导
         * */
        getOperationGuideList() {
            // 0或空为签到, 1抽验, 2签退
            if (this.signType.signType == 1) {
                // 抽验
                let list = ConstantsGuideCode.loginSamplingTrainGuideCodes.split(",");
                this.operationGuideListId = list;
            } else if (this.signType.signType == 2) {
                // 签退
                let list = ConstantsGuideCode.loginOutTrainGuideCodes.split(",");
                this.operationGuideListId = list;
            } else {
                let list = ConstantsGuideCode.loginTrainGuideCodes.split(",");
                this.operationGuideListId = list;
            }
            console.log("operationGuideListId", this.operationGuideListId);
        },
        /**
         * 进入检测操作引导
         */
        checkLivelearningOperationGuide() {
            if (this.isFristEntry) {
                this.isFristEntry = false;
                // 0或空为签到, 1抽验, 2签退
                if (this.signType.signType == 1) {
                    // 抽验
                    this.signSpotCheckOperationGuide();
                } else if (this.signType.signType == 2) {
                    // 签退
                    this.signOutCheckOperationGuide();
                } else {
                    // 签到
                    this.signInCheckOperationGuide();
                }
            }
        },
        /**
         * 签退检测操作引导
         */
        signOutCheckOperationGuide() {
            const that = this;
            GuideStepHelper.loadOperationGuideData(ConstantsGuideCode.loginOutTrainGuideCodes, function(dataList) {
                if (dataList == null || dataList.length == 0) {
                    return;
                }
                for (let i = 0; i < dataList.length; i++) {
                    const guide = dataList[i];
                    //是否已完成引导(0:未完成,1:已完成)
                    if (guide.guideDone == 0) {
                        const keyCode = guide.guideCode;

                        if (keyCode == "step211") {
                            TBDriver.addDriverStep(
                                HomeGuideSteps.createLivelearningGuideSteps(
                                    "#step211",
                                    "学员、监督人签退",
                                    "学员点击【签退】<br> 考核人员点击【签退】 <br> 安全管理员点击【签退】",
                                    null,
                                    211,
                                    211,
                                    false,
                                    true,
                                    false,
                                    ConstantsGuideCode.loginOutTrainGuideCodes
                                )
                            );
                        }
                        if (keyCode == "step212") {
                            TBDriver.addDriverStep(
                                HomeGuideSteps.createLivelearningGuideSteps(
                                    "#step212",
                                    "手机扫描签退",
                                    "学员、监督人员均可扫码签退",
                                    null,
                                    212,
                                    212,
                                    false,
                                    true,
                                    that.isHasLastStep(dataList, guide),
                                    ConstantsGuideCode.loginOutTrainGuideCodes
                                )
                            );
                        }
                        if (keyCode == "step213") {
                            TBDriver.addDriverStep(
                                HomeGuideSteps.createLivelearningGuideSteps(
                                    "#step213",
                                    "拍照验证",
                                    "点击【拍照验证】，左侧注册照和右侧人像进行验证",
                                    null,
                                    213,
                                    213,
                                    false,
                                    true,
                                    that.isHasLastStep(dataList, guide),
                                    ConstantsGuideCode.loginOutTrainGuideCodes
                                )
                            );
                        }

                        // if (keyCode == "step214") {
                        //     TBDriver.addDriverStep(
                        //         HomeGuideSteps.createLivelearningGuideSteps(
                        //             "#step214",
                        //             "签退记录",
                        //             "签退记录会显示签退成功的人员",
                        //             null,
                        //             214,
                        //             214,
                        //             false,
                        //             true,
                        //             that.isHasLastStep(dataList, guide),
                        //             ConstantsGuideCode.loginOutTrainGuideCodes
                        //         )
                        //     );
                        // }
                        if (keyCode == "step215") {
                            TBDriver.addDriverStep(
                                HomeGuideSteps.createLivelearningGuideSteps(
                                    "#step215",
                                    "退出现场学习",
                                    "学员全部签退完成后，点击【退出现场学习】，结束此次培训",
                                    null,
                                    215,
                                    215,
                                    true,
                                    false,
                                    that.isHasLastStep(dataList, guide),
                                    ConstantsGuideCode.loginOutTrainGuideCodes,
                                    "#409EFF"
                                )
                            );
                        }
                        TBDriver.startDriver();
                    }
                }
            });
        },

        /**
         * 抽验检测操作引导
         */
        signSpotCheckOperationGuide() {
            const that = this;
            GuideStepHelper.loadOperationGuideData(ConstantsGuideCode.loginSamplingTrainGuideCodes, function(dataList) {
                if (dataList == null || dataList.length == 0) {
                    return;
                }
                for (let i = 0; i < dataList.length; i++) {
                    const guide = dataList[i];
                    //是否已完成引导(0:未完成,1:已完成)
                    if (guide.guideDone == 0) {
                        const keyCode = guide.guideCode;

                        if (keyCode == "step216") {
                            TBDriver.addDriverStep(
                                HomeGuideSteps.createLivelearningGuideSteps(
                                    "#step216",
                                    "学员抽验",
                                    "学员点击【抽验】，列表中的学员均需要抽验",
                                    null,
                                    216,
                                    216,
                                    false,
                                    true,
                                    false,
                                    ConstantsGuideCode.loginSamplingTrainGuideCodes
                                )
                            );
                        }

                        if (keyCode == "step217") {
                            TBDriver.addDriverStep(
                                HomeGuideSteps.createLivelearningGuideSteps(
                                    "#step217",
                                    "手机扫码抽验",
                                    "学员可以扫码抽验",
                                    null,
                                    217,
                                    217,
                                    false,
                                    true,
                                    that.isHasLastStep(dataList, guide),
                                    ConstantsGuideCode.loginSamplingTrainGuideCodes
                                )
                            );
                        }

                        if (keyCode == "step218") {
                            TBDriver.addDriverStep(
                                HomeGuideSteps.createLivelearningGuideSteps(
                                    "#step218",
                                    "拍照验证",
                                    "点击【拍照验证】，左侧注册照和右侧人像进行验证",
                                    null,
                                    218,
                                    218,
                                    false,
                                    true,
                                    that.isHasLastStep(dataList, guide),
                                    ConstantsGuideCode.loginSamplingTrainGuideCodes
                                )
                            );
                        }

                        // if (keyCode == "step219") {
                        //     TBDriver.addDriverStep(
                        //         HomeGuideSteps.createLivelearningGuideSteps(
                        //             "#step219",
                        //             "抽验记录",
                        //             "抽验记录会显示抽验成功的人员",
                        //             null,
                        //             219,
                        //             219,
                        //             false,
                        //             true,
                        //             that.isHasLastStep(dataList, guide),
                        //             ConstantsGuideCode.loginSamplingTrainGuideCodes
                        //         )
                        //     );
                        // }
                        if (keyCode == "step220") {
                            const str = that.getTrainTypeReplaceStr;
                            TBDriver.addDriverStep(
                                HomeGuideSteps.createLivelearningGuideSteps(
                                    "#step220",
                                    `继续${str}`,
                                    `学员抽验完成后，点击【继续${str}】继续学习`,
                                    null,
                                    220,
                                    220,
                                    true,
                                    false,
                                    that.isHasLastStep(dataList, guide),
                                    ConstantsGuideCode.loginSamplingTrainGuideCodes
                                )
                            );
                        }
                    }
                }
                TBDriver.startDriver();
            });
        },

        /**
         * 签到检测操作引导
         */
        signInCheckOperationGuide() {
            // 签到
            const that = this;
            GuideStepHelper.loadOperationGuideData(ConstantsGuideCode.loginTrainGuideCodes, function(dataList) {
                if (dataList == null || dataList.length == 0) {
                    return;
                }
                for (let i = 0; i < dataList.length; i++) {
                    const guide = dataList[i];
                    //是否已完成引导(0:未完成,1:已完成)
                    if (guide.guideDone == 0) {
                        const keyCode = guide.guideCode;

                        if (keyCode == "step206") {
                            TBDriver.addDriverStep(
                                HomeGuideSteps.createLivelearningGuideSteps(
                                    "#step206",
                                    "监督人，学员签到",
                                    "安全管理员点击【签到】<br>考核人员点击【签到】<br>学员点击【签到】",
                                    null,
                                    206,
                                    206,
                                    false,
                                    true,
                                    false,
                                    ConstantsGuideCode.loginTrainGuideCodes
                                )
                            );
                        }
                        if (keyCode == "step207") {
                            TBDriver.addDriverStep(
                                HomeGuideSteps.createLivelearningGuideSteps(
                                    "#step207",
                                    "手机扫描签到",
                                    "监督人员或学员均可扫码签到",
                                    null,
                                    207,
                                    207,
                                    false,
                                    true,
                                    that.isHasLastStep(dataList, guide),
                                    ConstantsGuideCode.loginTrainGuideCodes
                                )
                            );
                        }
                        if (keyCode == "step208") {
                            TBDriver.addDriverStep(
                                HomeGuideSteps.createLivelearningGuideSteps(
                                    "#step208",
                                    "拍照验证",
                                    "点击【拍照验证】，左侧注册照和右侧人像进行验证",
                                    null,
                                    208,
                                    208,
                                    false,
                                    true,
                                    that.isHasLastStep(dataList, guide),
                                    ConstantsGuideCode.loginTrainGuideCodes
                                )
                            );
                        }

                        // if (keyCode == "step209") {
                        //     TBDriver.addDriverStep(
                        //         HomeGuideSteps.createLivelearningGuideSteps(
                        //             "#step209",
                        //             "签到记录",
                        //             "签到记录会显示签到成功的人员",
                        //             null,
                        //             209,
                        //             209,
                        //             false,
                        //             true,
                        //             that.isHasLastStep(dataList, guide),
                        //             ConstantsGuideCode.loginTrainGuideCodes
                        //         )
                        //     );
                        // }
                        if (keyCode == "step210") {
                            const str = that.getTrainTypeReplaceStr;
                            TBDriver.addDriverStep(
                                HomeGuideSteps.createLivelearningGuideSteps(
                                    "#step210",
                                    `开始${str}`,
                                    `学员签到完成后，点击【开始${str}】进行学习`,
                                    null,
                                    210,
                                    210,
                                    true,
                                    false,
                                    that.isHasLastStep(dataList, guide),
                                    ConstantsGuideCode.loginTrainGuideCodes
                                )
                            );
                        }
                        TBDriver.startDriver();
                    }
                }
            });
        },
        /**
         * 是有具有上一步 - lzb 20200903
         */
        isHasLastStep(dataList, codeItem) {
            if (!dataList || dataList.length == 0) {
                return false;
            }
            if (!codeItem) {
                return false;
            }

            const index = dataList.indexOf(codeItem);
            const computeList = dataList.filter((item, idx) => {
                return idx < index;
            });
            if (!computeList || computeList.length == 0) {
                return false;
            }
            for (let i = 0; i < computeList.length; i++) {
                const item = computeList[i];
                if (item.guideDone == 0) {
                    return true;
                }
            }
            return false;
        },

        /**
         * 检测记录的操作引导
         */
        checkRecordOperationGuide() {
            if (this.isFirstCheckRecordGuide) {
                this.isFirstCheckRecordGuide = false;
                // 0或空为签到, 1抽验, 2签退
                if (this.signType.signType == 1) {
                    // 抽验
                    this.signSpotCheckRecordOperationGuide();
                } else if (this.signType.signType == 2) {
                    // 签退
                    this.signOutCheckRecordOperationGuide();
                } else {
                    // 签到
                    this.signInCheckRecordOperationGuide();
                }
            }
        },
        /**
         * 签退检测操作引导
         */
        signOutCheckRecordOperationGuide() {
            const that = this;
            this.recordGuideId = "step214";
            GuideStepHelper.loadOperationGuideData(this.recordGuideId, function(dataList) {
                if (dataList == null || dataList.length == 0) {
                    return;
                }
                for (let i = 0; i < dataList.length; i++) {
                    const guide = dataList[i];
                    //是否已完成引导(0:未完成,1:已完成)
                    if (guide.guideDone == 0) {
                        const keyCode = guide.guideCode;
                        if (keyCode == "step214") {
                            TBDriver.addDriverStep(
                                HomeGuideSteps.createLivelearningGuideSteps(
                                    "#step214",
                                    "签退记录",
                                    "签退记录会显示签退成功的人员",
                                    null,
                                    214,
                                    214,
                                    true,
                                    true,
                                    false,
                                    that.recordGuideId
                                )
                            );
                        }
                        TBDriver.startDriver();
                    }
                }
            });
        },
        /**
         * 抽验检测操作引导
         */
        signSpotCheckRecordOperationGuide() {
            const that = this;
            this.recordGuideId = "step219";
            GuideStepHelper.loadOperationGuideData(this.recordGuideId, function(dataList) {
                if (dataList == null || dataList.length == 0) {
                    return;
                }
                for (let i = 0; i < dataList.length; i++) {
                    const guide = dataList[i];
                    //是否已完成引导(0:未完成,1:已完成)
                    if (guide.guideDone == 0) {
                        const keyCode = guide.guideCode;
                        if (keyCode == "step219") {
                            TBDriver.addDriverStep(
                                HomeGuideSteps.createLivelearningGuideSteps(
                                    "#step219",
                                    "抽验记录",
                                    "抽验记录会显示抽验成功的人员",
                                    null,
                                    219,
                                    219,
                                    true,
                                    true,
                                    false,
                                    that.recordGuideId
                                )
                            );
                        }
                        TBDriver.startDriver();
                    }
                }
            });
        },
        /**
         * 签到检测操作引导
         */
        signInCheckRecordOperationGuide() {
            const that = this;
            this.recordGuideId = "step209";
            GuideStepHelper.loadOperationGuideData(this.recordGuideId, function(dataList) {
                if (dataList == null || dataList.length == 0) {
                    return;
                }
                for (let i = 0; i < dataList.length; i++) {
                    const guide = dataList[i];
                    //是否已完成引导(0:未完成,1:已完成)
                    if (guide.guideDone == 0) {
                        const keyCode = guide.guideCode;
                        if (keyCode == "step209") {
                            TBDriver.addDriverStep(
                                HomeGuideSteps.createLivelearningGuideSteps(
                                    "#step209",
                                    "签到记录",
                                    "签到记录会显示签到成功的人员",
                                    null,
                                    209,
                                    209,
                                    true,
                                    true,
                                    false,
                                    that.recordGuideId
                                )
                            );
                        }
                        TBDriver.startDriver();
                    }
                }
            });
        },
    },
};
